import React, { Component } from 'react'
// import { BrowserRouter as Router } from "react-router-dom"
import ScrollToTop from './components/ScrollToTop'
import { connect } from 'react-redux'
import { ConnectedRouter } from "connected-react-router"
import { history } from "./redux/store"
import { bindActionCreators } from 'redux'
import * as prismicActions from './redux/actions/prismicActions'
import * as globalActions from './redux/actions/globalActions'
import Cookies from 'js-cookie'
import Prismic from 'prismic-javascript'
import getUrlParam from './plugins/getUrlParam'
import localeConfig from './config/locale'
import newrelicJs from "./plugins/newrelic";
import Header from './components/Header'
import Footer from './components/Footer'
import Routes from './router/routes'
import './styles/App.scss'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // allPrismicData: null
    }
  }

  componentWillMount() {  
    // Setting the locale var into localeStorage
    const localStorageLocale = localStorage.getItem(localeConfig.name)

    if (localStorageLocale !== localeConfig.lang1 || localStorageLocale !== localeConfig.lang2 ) {
      localStorage.setItem(localeConfig.name, localeConfig.default)
    }

    this.props.fetchPrismic(this.props.locale)
    this.fetchPrismicData(this.props) 

    // this.fetchAllPrismicData(this.props)

    // Setting .ready onto HTML tag to hide the elements for react snap
    const lsObj = JSON.parse(localStorage.getItem('altavie_agegate'));
    const seObj = JSON.parse(sessionStorage.getItem('altavie_agegate'));
    if((lsObj && Date.now() < lsObj.expiresAt) || seObj){
      document.querySelector('html').classList.add('ready');
    }

    // After the document is ready, show the modal to prevent double rendering
    // let htmlTag = document.getElementById('html')  
    // let currentPath = window.location.pathname

    // function hasClass(element, className) {
    //   return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
    // }

    // if(hasClass(htmlTag, 'ready') && currentPath !== 'age-gate') {
    //   this.props.toggleNewsletter(true);
    // }

    // Inject new relic script
    const script = document.createElement("script");
    script.id = "newrelicJs";
    script.innerHTML = window.eval(JSON.stringify(newrelicJs));
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  componentDidUpdate() {
    // After the document is ready, show the modal to prevent double rendering
    // let htmlTag = document.getElementById('html')  
    // let currentPath = window.location.pathname

    // function hasClass(element, className) {
    //   return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
    // }

    // if(hasClass(htmlTag, 'ready') && currentPath !== 'age-gate') {
    //   this.props.toggleNewsletter(true)
    // }
  }

  componentWillReceiveProps(props) {
    this.fetchPrismicData(props)
    // this.fetchAllPrismicData(props)

    // Setting the getUrlParam function, if the user adds ?locale=en-ca into the url, it will change the localStorage var
    if(getUrlParam('locale')) {
      localStorage.setItem(localeConfig.name, getUrlParam('locale'))
      props.toggleLocale(localStorage.getItem(localeConfig.name))
    }   
  }

  fetchPrismicData(props) {
    if(props.prismicCtx) {
      // // Preview Cookie for Prismic Previews
      const previewRef = Cookies.get(Prismic.previewCookie);
      const masterRef = props.prismicCtx.api.refs.find(ref => { return ref.isMasterRef === true }).ref;
      const ref = previewRef || masterRef;


      return props.prismicCtx.api.query('', {
          ref,
          lang: props.locale,
          pageSize: 100,
          fetchLinks: [
            'product_page.product_title',
            'product_page.product_banner_image',
            'product_page.strain_thc_levels',
            'product_page.strain_cbd_levels',
            'product_page.strain_type',
          ]
        }).then(response => {
          props.getPrismicData(response)
      })
    }
  }

  // fetchAllPrismicData(props) {
  //   if(props.prismicCtx) {
  //     return props.prismicCtx.api.query('', {
  //         lang: '*',
  //         pageSize : 100,
  //       }).then(response => {
  //         this.setState({allPrismicData: response})
  //     })
  //   }
  // }

  render() {
    let { 
      menuOpen, 
      locale, 
      toggleLocale 
    } = this.props

     ///////////////////////////////////////////////////////////////////////////////////////////
    // Grab all UIDs and make sure the right language is set when entering the UID into the URL
    ///////////////////////////////////////////////////////////////////////////////////////////

    if(this.state.allPrismicData) {
      let currentPath = window.location.pathname
      let enPaths = ['our-strains', 'news-and-events', 'where-to-buy', 'privacy-policy', 'frequently-asked-questions']
      let frPaths = ['nos-souches', 'infos-et-evenements', 'ou-acheter', 'declaration-de-confidentialite', 'questions-frequemment-posees']

      // let enPaths = this.state.allPrismicData.results
      //   .filter(result => result.lang === localeConfig.lang1 && result.uid)
      //   .map(path => path.uid)
      // let frPaths = this.state.allPrismicData.results
      //   .filter(result => result.lang === localeConfig.lang2 && result.uid)
      //   .map(path => path.uid)
      
      // console.log(this.state.allPrismicData)
      // console.log(currentPath)
      // console.log(enPaths)
      // console.log(frPaths)

      enPaths.forEach((item) => {
        if (currentPath.includes(item)) {
          if (locale === localeConfig.lang2) {
            localStorage.setItem(localeConfig.name, localeConfig.lang1)
            toggleLocale(localStorage.getItem(localeConfig.name))
            locale === localeConfig.lang1
            return false;
          } else {
            localStorage.setItem(localeConfig.name, localeConfig.lang2)
          }
        }
      });

      frPaths.forEach((item) => {
        if (currentPath.includes(item)) {
          if (locale === localeConfig.lang1) {
            localStorage.setItem(localeConfig.name, localeConfig.lang2)
            toggleLocale(localStorage.getItem(localeConfig.name))
            locale === localeConfig.lang2
            return false;
          } else {
            localStorage.setItem(localeConfig.name, localeConfig.lang1)
          }
        }
      });

      if (currentPath.includes('medias') || currentPath.includes('contactez-nous')) {
        if (locale === localeConfig.lang1) {
          localStorage.setItem(localeConfig.name, localeConfig.lang2);
          toggleLocale(localStorage.getItem(localeConfig.name));
          locale === localeConfig.lang2;
        }
      } else if (currentPath.includes('media') && !currentPath.includes('medias')) {
        if (locale === localeConfig.lang2) {
          localStorage.setItem(localeConfig.name, localeConfig.lang1);
          toggleLocale(localStorage.getItem(localeConfig.name));
          locale === localeConfig.lang1;
        }
      } else if (currentPath.includes('contact') && !currentPath.includes('contactez-nous')) {
        if (locale === localeConfig.lang2) {
          localStorage.setItem(localeConfig.name, localeConfig.lang1);
          toggleLocale(localStorage.getItem(localeConfig.name));
          locale === localeConfig.lang1;
        }
      }
    }
    //////////
    // END //
    //////////

    return (
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <div className={`App ${localStorage.getItem('localeAltaVie')}`}>
            <Header />
            <div className={`main-container ${menuOpen === true ? 'active' : ''}`}>
              <Routes />
            <Footer /> 
            </div>
          </div>
        </ScrollToTop>
      </ConnectedRouter>
    )
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
  menuOpen: state.global.menuOpen
})

const mapDispatchToProps = dispatch => 
  bindActionCreators(
    {
      fetchPrismic: prismicActions.fetchPrismic,
      getPrismicData: prismicActions.getPrismicData,
      toggleLocale: globalActions.toggleLocale,
      // toggleNewsletter: globalActions.toggleNewsletter,
    },
    dispatch
  )



export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js